import { memo } from 'react';
import { parseISO } from 'date-fns';
import Popover from 'antd/lib/popover';
import { DEFAULT_DATE_TIME_FORMAT, getComputerFormattedTime, getTimezoneFormattedTime, getUtcFormattedTime } from 'src/domain/date/date';
import './datetimePopover.css';

interface IDatetimePopover {
    timestamp: number;
    dateFormat?: string;
    timeZone?: string;
    siteName?: string;
    inline?: boolean;
}

function getUtcDate(timestamp: number): Date {
    return parseISO(new Date(timestamp).toISOString());
}

export function DatetimePopover({ timestamp, dateFormat = DEFAULT_DATE_TIME_FORMAT, timeZone, siteName, inline = false }: IDatetimePopover) {
    const utcDate = getUtcDate(timestamp);
    const utcFormattedTime = getUtcFormattedTime(utcDate, dateFormat);
    const timezoneFormattedTime = getTimezoneFormattedTime(utcDate, timeZone, dateFormat);
    const computerFormattedTime = getComputerFormattedTime(utcDate, dateFormat);

    let label: string = computerFormattedTime;
    let content: JSX.Element | null = (
        <div className="datetime-popover">
            <p>UTC: {utcFormattedTime}</p>
            <p>Computer: {computerFormattedTime}</p>
        </div>
    );

    if (timeZone) {
        content = (
            <div className="datetime-popover">
                <p>
                    {siteName ? `Site (${siteName}): ` : 'Site: '}
                    {timezoneFormattedTime}
                </p>
                <p>Computer: {computerFormattedTime}</p>
                <p>UTC: {utcFormattedTime}</p>
            </div>
        );
    }

    return (
        <Popover content={content}>
            <div data-cy="date-time" style={{ display: inline ? 'inline' : 'block' }}>
                {label}
            </div>
        </Popover>
    );
}

export const MemoizedDatetimePopover = memo(DatetimePopover);
